import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

// Design system styles — must come before any component imports that use
// Tailwind classes. Order: tokens.css (CSS custom properties) then
// tailwind.css (utility classes + a couple of design-system globals).
import './design-system/tokens.css'
import './styles/tailwind.css'

// React 18 root API — replaces the legacy ReactDOM.render entry point.
const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App />)
